import type { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: ReactNode;
}

const variants = {
  primary: 'bg-white/90 text-[#0F172A] hover:bg-white shadow-[0_0_20px_rgba(255,255,255,0.06)]',
  secondary: 'bg-transparent text-white/50 border border-white/[0.08] hover:text-white/80 hover:border-white/[0.18] hover:bg-white/[0.03]',
  ghost: 'bg-transparent text-white/40 hover:text-white/70',
};

const sizes = {
  sm: 'px-5 py-2.5 text-[11px]',
  md: 'px-8 py-3.5 text-[12px]',
  lg: 'px-10 py-4 text-[13px]',
};

export function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  disabled,
  children,
  ...props
}: ButtonProps) {
  return (
    <button
      className={`
        font-mono font-semibold tracking-[0.12em] uppercase rounded-lg transition-all duration-300 cursor-pointer
        ${variants[variant]}
        ${sizes[size]}
        ${disabled ? 'opacity-40 cursor-not-allowed' : ''}
        ${className}
      `}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
